import { useEffect, useState } from 'react';

import { PageTitle } from 'presentation/components/PageTitle';

import { Button, Pagination } from 'antd';
import { PropertyUseCaseInterface } from 'application/usecases/PropertyUseCase';
import { ParamsProperty } from 'domain/entities/PropertyEntity';
import { ListNoData } from 'presentation/components/ListNoData';
import { openErrorNoti } from 'presentation/components/Notification';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { CardComponent } from './components/Card';
import { convertDataListProperty } from './hepler';
import { DataListProperty } from './models/Model_CU-029-01';
interface props {
    propertyUseCase: PropertyUseCaseInterface;
}

const CU02901Page = ({ propertyUseCase }: props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [listProperty, setListProperty] = useState<DataListProperty[]>([]);
    const [page, setPage] = useState<number>(1);
    const [numPages, setNumPages] = useState<number>(1);
    const [totalRecord, setTotalRecord] = useState<number>(0);
    const keyword = searchParams.get('keywordProperty') || '';
    const pageSize = 12;

    useEffect(() => {
        getListProperty({ keyword: keyword, page: page, pageSize: pageSize });
    }, [page]);

    const getListProperty = async (params: ParamsProperty) => {
        try {
            dispatch(startFetching());
            const response: any = await propertyUseCase.getListProperty({
                ...params,
                sortBy: 'name',
                sortType: 'asc',
            });
            setNumPages(response?.result?.pagination?.numPages);
            setTotalRecord(response?.result?.pagination?.count ?? 0);
            setListProperty(convertDataListProperty(response?.result?.data) ?? []);
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const handlePageChange = (newPage: number) => {
        setPage(newPage);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleViewDetail = (value: number) => {
        navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_030_01}/${value}`);
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
                textAlign: 'center',
                overflowX: 'hidden',
                overflowY: 'auto',
            }}
            className="CU-029-01-container"
        >
            <section
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    paddingRight: 40,
                }}
            >
                <PageTitle title="くわしく査定" />
                {totalRecord > 0 && (
                    <div style={{ fontSize: 16, fontWeight: 500, color: '#000000' }}>
                        検索結果：{totalRecord}件
                    </div>
                )}
            </section>

            {listProperty.length > 0 ? (
                <section
                    style={{
                        height: '100%',
                        overflowX: 'hidden',
                        overflowY: 'auto',
                        flexGrow: 1,
                    }}
                    className="wrapper-card"
                >
                    <div style={{ width: 'fit-content' }}>
                        <div className="grid-container">
                            {listProperty.map((element: DataListProperty, index: number) => (
                                <CardComponent
                                    key={index}
                                    data={element}
                                    onClickViewDetail={(e) => handleViewDetail(e)}
                                />
                            ))}
                        </div>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: 20,
                            marginBottom: 20,
                        }}
                    >
                        <Pagination
                            current={page}
                            pageSize={pageSize}
                            total={totalRecord}
                            showLessItems
                            showSizeChanger={false}
                            onChange={handlePageChange}
                            style={{ margin: '20px 0', textAlign: 'center' }}
                        />
                    </div>
                </section>
            ) : (
                <div style={{ paddingRight: 40 }}>
                    <ListNoData />
                </div>
            )}

            <section style={{ marginTop: 60 }}>
                <Button
                    className="button-login-text "
                    type="primary"
                    style={{ width: 343, height: 56 }}
                    onClick={() =>
                        navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_029_02}`)
                    }
                >
                    見つからない場合はこちら
                </Button>
            </section>
        </div>
    );
};

export default CU02901Page;
